/**
 * Rituel quotidien de l'espace élève — mission du jour + sauvegarde de flamme.
 * FRONT-ONLY : la frontière de journée est estimée en fuseau LOCAL (le back a
 * sa propre règle) → formulations prudentes (« ce soir », jamais de décompte).
 */

const LAST_QUIZ_DAY_KEY = 'tanoLastQuizDay';

/** Deux dates tombent-elles le même jour LOCAL ? */
export const sameLocalDay = (a, b) => {
    const da = new Date(a);
    const db = new Date(b);
    return !Number.isNaN(da.getTime()) && !Number.isNaN(db.getTime())
        && da.getFullYear() === db.getFullYear()
        && da.getMonth() === db.getMonth()
        && da.getDate() === db.getDate();
};

/** À appeler quand un récap XP se déclenche (un quiz vient d'être soumis). */
export const marquerQuizDuJour = () => {
    try { localStorage.setItem(LAST_QUIZ_DAY_KEY, new Date().toISOString()); } catch { /* no-op */ }
};

/**
 * La flamme est-elle déjà « sauvée » aujourd'hui ?
 * Source principale : les transactions XP normalisées ({ date }) ; repli :
 * la marque locale posée au dernier récap (best-effort mono-appareil).
 */
export const flammeSauveeAujourdhui = (transactions) => {
    const auj = new Date();
    if (Array.isArray(transactions) && transactions.some(t => t?.date && sameLocalDay(t.date, auj))) return true;
    try {
        const marque = localStorage.getItem(LAST_QUIZ_DAY_KEY);
        return !!marque && sameLocalDay(marque, auj);
    } catch { return false; }
};

/**
 * Mission du jour → { type, titre, sousTitre, mood } :
 *  - flamme-danger : série en cours, pas encore jouée aujourd'hui, de quoi
 *                    la sauver (quiz du prof OU défi quotidien) ;
 *  - quiz-attend  : des quiz du prof en attente ;
 *  - defi         : rien du prof mais des défis quotidiens restants ;
 *  - tout-fait    : plus rien à faire, flamme sauvée ;
 *  - repos        : rien en attente.
 */
export const getMission = ({ pending = 0, nextQuizTitre = '', flammeJours = 0, flammeSauvee = false, defisRestants = 0 }) => {
    if (flammeJours > 0 && !flammeSauvee && (pending > 0 || defisRestants > 0)) {
        return {
            type: 'flamme-danger',
            titre: 'Ta flamme s\'éteint ce soir !',
            sousTitre: pending > 0
                ? `Fais 1 quiz pour sauver ta série de ${flammeJours} jour${flammeJours > 1 ? 's' : ''} 🔥`
                : `Fais 1 défi ⚡ pour sauver ta série de ${flammeJours} jour${flammeJours > 1 ? 's' : ''} 🔥`,
            mood: 'angry',
        };
    }
    if (pending > 0) {
        return {
            type: 'quiz-attend',
            titre: 'Ta mission du jour',
            sousTitre: nextQuizTitre ? `Termine « ${nextQuizTitre} »` : 'Un quiz t\'attend sur ton île !',
            mood: 'joy',
        };
    }
    if (defisRestants > 0) {
        return {
            type: 'defi',
            titre: '🌋 Le volcan gronde !',
            sousTitre: `Va chercher ton énergie — ${defisRestants} défi${defisRestants > 1 ? 's' : ''} à gagner aujourd'hui pour le réveiller !`,
            mood: 'joy',
        };
    }
    if (flammeSauvee) {
        return {
            type: 'tout-fait',
            titre: 'Mission accomplie !',
            sousTitre: 'Tout est fait pour aujourd\'hui. Reviens demain !',
            mood: 'sleep',
        };
    }
    return {
        type: 'repos',
        titre: 'Rien à faire pour l\'instant',
        sousTitre: 'Explore ton île ou admire tes blasons en attendant !',
        mood: 'idle',
    };
};
